"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$ = exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$outboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$inboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$ = exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$outboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$inboundSchema = void 0;
exports.getCompanyDetailsCompaniesCompanyNumberGetSecurityToJSON = getCompanyDetailsCompaniesCompanyNumberGetSecurityToJSON;
exports.getCompanyDetailsCompaniesCompanyNumberGetSecurityFromJSON = getCompanyDetailsCompaniesCompanyNumberGetSecurityFromJSON;
exports.getCompanyDetailsCompaniesCompanyNumberGetRequestToJSON = getCompanyDetailsCompaniesCompanyNumberGetRequestToJSON;
exports.getCompanyDetailsCompaniesCompanyNumberGetRequestFromJSON = getCompanyDetailsCompaniesCompanyNumberGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCompanyDetailsCompaniesCompanyNumberGetSecurity$;
(function (GetCompanyDetailsCompaniesCompanyNumberGetSecurity$) {
    /** @deprecated use `GetCompanyDetailsCompaniesCompanyNumberGetSecurity$inboundSchema` instead. */
    GetCompanyDetailsCompaniesCompanyNumberGetSecurity$.inboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$inboundSchema;
    /** @deprecated use `GetCompanyDetailsCompaniesCompanyNumberGetSecurity$outboundSchema` instead. */
    GetCompanyDetailsCompaniesCompanyNumberGetSecurity$.outboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$outboundSchema;
})(GetCompanyDetailsCompaniesCompanyNumberGetSecurity$ || (exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$ = GetCompanyDetailsCompaniesCompanyNumberGetSecurity$ = {}));
function getCompanyDetailsCompaniesCompanyNumberGetSecurityToJSON(getCompanyDetailsCompaniesCompanyNumberGetSecurity) {
    return JSON.stringify(exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$outboundSchema.parse(getCompanyDetailsCompaniesCompanyNumberGetSecurity));
}
function getCompanyDetailsCompaniesCompanyNumberGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCompanyDetailsCompaniesCompanyNumberGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetCompanyDetailsCompaniesCompanyNumberGetSecurity' from JSON`);
}
/** @internal */
exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$inboundSchema = z.object({
    company_number: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_number": "companyNumber",
    });
});
/** @internal */
exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$outboundSchema = z.object({
    companyNumber: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyNumber: "company_number",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCompanyDetailsCompaniesCompanyNumberGetRequest$;
(function (GetCompanyDetailsCompaniesCompanyNumberGetRequest$) {
    /** @deprecated use `GetCompanyDetailsCompaniesCompanyNumberGetRequest$inboundSchema` instead. */
    GetCompanyDetailsCompaniesCompanyNumberGetRequest$.inboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$inboundSchema;
    /** @deprecated use `GetCompanyDetailsCompaniesCompanyNumberGetRequest$outboundSchema` instead. */
    GetCompanyDetailsCompaniesCompanyNumberGetRequest$.outboundSchema = exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$outboundSchema;
})(GetCompanyDetailsCompaniesCompanyNumberGetRequest$ || (exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$ = GetCompanyDetailsCompaniesCompanyNumberGetRequest$ = {}));
function getCompanyDetailsCompaniesCompanyNumberGetRequestToJSON(getCompanyDetailsCompaniesCompanyNumberGetRequest) {
    return JSON.stringify(exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$outboundSchema.parse(getCompanyDetailsCompaniesCompanyNumberGetRequest));
}
function getCompanyDetailsCompaniesCompanyNumberGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCompanyDetailsCompaniesCompanyNumberGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetCompanyDetailsCompaniesCompanyNumberGetRequest' from JSON`);
}
//# sourceMappingURL=getcompanydetailscompaniescompanynumberget.js.map